import { styled } from "@mui/system";
import { StyledComponent } from "@emotion/styled";
import { FaSearch } from "react-icons/fa";

import { colors, others } from "../../../styles/colors";

import {
  Popper,
  PopperProps,
  autocompleteClasses,
  styled as styledComponent,
} from "@mui/material";

export const ReadOnlyFieldContainer = () => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minWidth: 0,
    color: colors.black[1],
});

export const ReadOnlyFieldLabel = () => ({
    marginBottom: "0.25rem",
    whiteSpace: "nowrap",
});

export const ReadOnlyFieldValue = () => ({
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    minHeight: "1.8rem"
});

export const ReadOnlyFieldIcon = () => ({
    marginTop: "0.15rem",
    flexShrink: 0,
    alignItems: "center",
});

export const ReadOnlyFieldValueStyle = () => ({
    wordBreak: "break-word",
    overflowWrap: "anywhere",
});

export const FaSearchIcon = styled(FaSearch)((props) => ({
  marginRight: "0.65rem",
  color: props.theme.palette.primary.main,
  fontSize: ".80rem",
}));

export const AutocompleteTableHolder = () => ({
  width: "inherit",
  top: "1rem",
  borderRadius: "0.19rem",
  paddingBottom: "1rem",
});

export const StyledPopper: StyledComponent<PopperProps> = styledComponent(
  Popper
)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: "border-box",
    "& ul": {
      padding: 0,
      margin: 0,
    },
    "& .MuiAutocomplete-option": {
      padding: "unset",
      cursor: "auto",
    },
    "&::-webkit-scrollbar": {
      width: ".25rem",
      height: "0.3rem",
      paddingLeft: "2rem",
    },
    "&::-webkit-scrollbar-track": {
      width: 0.4,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: colors.black[6],
      borderRadius: 0.5,
      width: 0.3,
    },
  },
});

export const AutoCompletePaper = (width?: string) => ({
  "&.MuiAutocomplete-paper": {
    width: width || "42rem",
    height: "fit-content",
    border: `1px solid ${colors.borders[1]}`,
    marginLeft: "0rem",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  },
});

export const AvailableRecords = () => ({
  height: "2rem",
  padding: "0.5rem",
  paddingLeft: "1rem",
});

export const PhysicianRecordHeader = () => ({
  backgroundColor: others.MainBackground[1],
  width: "100%",
  padding: "0.5rem",
  paddingLeft: "0.5rem",
  textAlign: "center",
});

export const SearchedResultTableHead = () => ({
  padding: "0.5rem",
  backgroundColor: colors.backgroundColor[8],
  borderBottom: 0,
  "&.MuiTableCell-root:first-of-type": {
    borderTopLeftRadius: "0.19rem",
    borderBottomLeftRadius: "0.19rem",
    paddingLeft: "1.5rem",
  },
  "&.MuiTableCell-root:last-child": {
    borderTopRightRadius: "0.19rem",
    borderBottomRightRadius: "0.19rem",
  },
});

export const InputSearchIconUI = () => ({
  color: colors.fonts[9],
  paddingRight: ".25rem",
  fontSize: "1.4rem",
});